import CityPageTemplate from "../hawaii-city/CityPageTemplate";
import { mililaniConfig } from "./data";

export default function Page() {
  return <CityPageTemplate config={mililaniConfig} />;
}